<template>
  <v-container class="py-6">
    <v-responsive max-width="700" class="mx-auto text-center">
      <!-- <div class="text-overline secondary--text mb-3">Account</div> -->
      <h2 class="text-h3 text-lg-h2 mb-6">Sign Up</h2>
    </v-responsive>

    <v-card class="pa-4 mx-auto" max-width="600">
      <v-card-text>
        <v-text-field
          v-model="store_name"
          label="Store name"
          outlined
        ></v-text-field>

        <v-text-field
          v-model="email"
          label="Email"
          outlined
        ></v-text-field>

        <v-text-field
          label="Password"
          v-model="password"
          v-bind:type="showPassword ? 'text' : 'password'"
          v-bind:append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
          @click:append="showPassword = !showPassword"
          outlined
        ></v-text-field>

        <v-btn
          block
          class="secondary"
          x-large
          :loading="this.loading"
          @click="registerWithFirebase"
        >Create Account</v-btn>

        <div class="text-center mt-3 text-body-2">
          Already have an account?
          <router-link to="/login">Sign in</router-link>
        </div>

      </v-card-text>
    </v-card>
  </v-container>
</template>


<script>
import { getAuth, sendEmailVerification, createUserWithEmailAndPassword } from "firebase/auth";

export default {
  name: 'Signup',

  data: () => ({
    showPassword: false,
    store_name: '',
    email: '',
    password: '',
    loading: false,
  }),

  methods: {
    registerWithFirebase() {
      this.loading = true
      // var actionCodeSettings = {
      //   url: `${process.env.VUE_APP_API_ORIGIN}/#/`,
      // };

      const auth = getAuth();
      createUserWithEmailAndPassword(auth, this.email, this.password)
      .then(res => {

        // sendEmailVerification(auth.currentUser, actionCodeSettings)
        // .then(() => {
          this.registerWithDjango()
        // })
        // .catch((e) => {
        //   this.loading = false
        //   alert(e);
        // });

      })
      .catch((e) => {
        this.loading = false
        alert(e);
      });
    },

    registerWithDjango() {
      // django側のAPIに新規登録を投げる
      this.axios
      .post(`${process.env.VUE_APP_API_ORIGIN}/account/register`, {
        email: this.email,
        store_name: this.store_name
      })
      .then(() => {
        this.$router.push({ name: 'Login' })
      })
      .catch((e) => {
        this.loading = false
        alert(e);
      });
    },
  }
};
</script>
